module.exports = __webpack_public_path__ + "img/idc.a1060621.jpg";